'use client';
import Button from '@/presentation/components/elements/Button';
import Providers from './[chain]/Providers';
import FrameWithSidebar from '@/presentation/components/layouts/FrameWithSidebar';
import ModalManager from '@/presentation/components/modules/ModalManager';
import Sidebar from '@/presentation/components/sections/Sidebar';
import Topbar from '@/presentation/components/sections/Topbar';
import { useEffect, useState } from 'react';

export const metadata = {
  title: 'Buy, Sell, and Swap NFTs instantly on NFTX V3',
  description:
    'Trade on the NFTX marketplace & earn yield by providing liquidity for popular NFT Collections such as CryptoPunks, Milady Maker or Pudgy Penguins.',
};

export default function NotFound() {
  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    // Set the current URL after the component mounts
    setCurrentUrl(window.location.pathname);
  }, []);

  const chainSlug = currentUrl?.split('/')[1] || 'eth';

  return (
    <Providers chainSlug={chainSlug}>
      <div className="flex flex-col min-h-screen">
        <FrameWithSidebar
          aside={<Sidebar />}
          header={<Topbar />}
          main={
            <div className="container p-10 text-center flex-1 flex justify-center items-center flex-col space-y-6">
              <h1 className="text-center text-5xl font-bold">{'404'}</h1>
              <p>{`Whoops, we couldn't find that...`}</p>
              <p>
                <Button href={`/${chainSlug}/collections`}>
                  {'Back to collections'}
                </Button>
              </p>
            </div>
          }
        />
      </div>
      <ModalManager />
    </Providers>
  );
}
